import { RootStateType } from '../store';

export const getDebugEnabled = ({ debug }: RootStateType) => debug.enabled;
export const getForceOrderRoute = ({ debug }: RootStateType) =>
  debug.forceOrderRoute;
export const selectMarketExecutionForLimitOrderDisabled = ({
  debug,
}: RootStateType) => debug.marketExecutionForLimitOrderDisabled;
export const getDisabledEstimateGas = ({ debug }: RootStateType) =>
  debug.estimateGasDisabled;
